import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import FormContext from "../context/formContext";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import BackLogout from "../component/backLogout";
import Loader from "../component/loader";
// import { useNavigate } from "react-router-dom";
// import { useNavigate } ";
function FormPage3() {
  const toast = useToast();
  const context = useContext(FormContext);
  const { loginObj, setLoginObj } = context;

  const navigate = useNavigate();

  const [isChecked, setIsChecked] = useState(false);
  const [fp3loader, setFP3loader] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    // Prompt confirmation when reload page is triggered
    window.onbeforeunload = () => {
      return "";
    };
    window.scrollTo(0, 0);

    // Unmount the window.onbeforeunload event
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  // eslint-disable-next-line
  const [base_url, setBase_Url] = useState(
    "https://erpapi.eshiksa.net/Gadvasu"
  );

  const imageUploaded = async (e) => {
    const file = e.target.files[0];
    const fileSizeLimit = 1 * 1024 * 1024;

    // Split the file name by dot to get the extension
    const fileNameParts = file.name.split(".");
    const extensionfront = fileNameParts[fileNameParts.length - 1];

    var extension = e.target.files[0].type.split(".").at(-1).split("/")[1];
    const allowedFileTypes = ["jpg", "png", "jpeg"];
    if (!allowedFileTypes.includes(extension)) {
      toast({
        title: "Alert",
        description: `File does not support. Files type must be ${allowedFileTypes.join(
          ", "
        )}`,
        status: "warning",
        duration: 1000,
        isClosable: true,
        position: "top",
      });
      e.target.value = null;
      return false;
    } else {
      if (file && file.size <= fileSizeLimit) {
        if (allowedFileTypes.includes(extensionfront)) {
          let formData = new FormData();
          formData.append("uploadImage", file);
          // formData.append("Branch_id", "1790");
          formData.append("Branch_id", "2245");
          formData.append("db_name", "erp_eshiksa");
          formData.append("student_id", localStorage.getItem("studentId"));
          await axios
            .post(
              "https://erpapi.eshiksa.net/Gadvasu/uploadImage.php",
              formData
            )
            .then(function (response) {
              // setLoading(false);
              if (response.status === 200) {
                toast({
                  title: "Alert",
                  description: response.data.msg,
                  status: "success",
                  duration: 1000,
                  isClosable: true,
                  position: "top",
                });
                let key = e.target.name;
                let filePath = response.data.file_path;
                // console.log(key,filePath)
                //console.log(response.data)
                setLoginObj({ ...loginObj, [key]: filePath });
              } else {
                toast({
                  title: "Alert",
                  description: "Something Went Wrong",
                  status: "warning",
                  duration: 1000,
                  isClosable: true,
                  position: "top",
                });
              }
            })
            .catch(function (error) {
              // setLoading(false);
              console.log(error);
            });
        }
      } else {
        e.target.value = "";
        toast({
          title: "Alert",
          description: "Please Select file size upto 1 mb",
          status: "warning",
          duration: 1000,
          isClosable: true,
          position: "top",
        });
      }
    }
  };

  const handleSaveFormPage3 = () => {
    loginObj["student_id"] = localStorage.getItem("studentId");
    loginObj["db_name"] = "erp_eshiksa";
    loginObj["email"] = localStorage.getItem("email");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=gliuijh4lm0h2rlafbvtgo6r8vj6f9if");
    myHeaders.append("auth_token", localStorage.getItem("token"));

    var raw = JSON.stringify(loginObj);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("https://erpapi.eshiksa.net/Gadvasu/SaveData.php", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        var responseObjFS = JSON.parse(result);
        console.log(responseObjFS);
        if (responseObjFS.success === 1) {
          toast({
            title: "Alert",
            description: responseObjFS.msg,
            status: "success",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
          navigate("/FormPreview");
        }
      })
      .catch((error) => console.log("error", error));
  };



  // const handleSubmitFormPage3 = (e) => {
  //   e.preventDefault();
  //   setFP3loader(true);
  //   setIsChecked(false);

  //   if (
  //     // loginObj.NEETAIR === loginObj.NEETAIRcheck &&
  //     // loginObj.NEETRollNocheck === loginObj.neetRollNo
  //     loginObj.NEETAIR === loginObj.NEETAIRcheck &&
  //     loginObj.NEETRollNocheck === loginObj.neetRollNo &&
  //     loginObj.neetscoreobt === loginObj.neetscore
  //   ) {
  //     handleSaveFormPage3();
  //   } else {
  //     setFP3loader(false);
  //     setIsChecked(true);
  //     toast({
  //       title: "Alert",
  //       description: "Your Neet information does not match",
  //       status: "error",
  //       duration: 1000,
  //       isClosable: true,
  //       position: "top",
  //     });
  //   }
  // };

  const handleSubmitFormPage3 = (e) => {
    e.preventDefault();
    setFP3loader(true);
    setIsChecked(false);
    handleSaveFormPage3();
  };

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=ks1r6e3hp01h9psp1ufu608e45l56ri4");
    myHeaders.append("auth_token", localStorage.getItem("token"));

    var raw = JSON.stringify({
      // Branch_id: "1790",
      Branch_id: "2245",
      student_id: localStorage.getItem("studentId"),
      db_name: "erp_eshiksa",
      email: localStorage.getItem("email"),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/getStudentData.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        var resultObj = JSON.parse(result);
        console.log(resultObj);

        if (resultObj.success === 1) {
          setFP3loader(false);
          setIsChecked(false);

          setLoginObj(resultObj.form_data);
        }
      })
      .catch((error) => console.log("error", error));
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <div className="container">
        <div>
          <button
            className="btn btn-sm my-2 "
            style={{ border: "1px solid #a6191f", color: "#a6191f" }}
          >
            {" "}
            <i className="fa-solid fa-user mx-2"> </i>
            {loginObj.name}
          </button>

          <BackLogout />
        </div>

        <form onSubmit={(e) => handleSubmitFormPage3(e)}>
          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">
                  Documents Details{" "}
                  <span className="float-end">Max. file size = 1 mb.</span>{" "}
                </h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <div className="mb-3">
                  <label for="formFile" className="form-label">
                    Photograph*
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    name="photograph"
                    onChange={(e) => {
                      if (e.target.files.length === 0) {
                        return null;
                      } else {
                        imageUploaded(e);
                      }
                    }}
                    required={loginObj.photograph ? false : true}
                  />
                  {loginObj.photograph && (
                    <a
                      className="text-decoration-none"
                      rel="noreferrer"
                      target="_blank"
                      href={base_url + loginObj.photograph}
                    >
                      View Uploaded File
                    </a>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-lg-4">
                <div className="mb-3">
                  <label for="formFile" className="form-label">
                    Signature of Applicant* : &nbsp;
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    name="signature"
                    onChange={(e) => {
                      if (e.target.files.length === 0) {
                        return null;
                      } else {
                        imageUploaded(e);
                      }
                    }}
                    required={loginObj.signature ? false : true}
                  />

                  {loginObj.signature && (
                    <a
                      className="text-decoration-none"
                      rel="noreferrer"
                      target="_blank"
                      href={base_url + loginObj.signature}
                    >
                      View Uploaded File
                    </a>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-lg-4">
                <div className="mb-3">
                  <label for="formFile" className="form-label">
                    Left Thumb Impression*
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    name="left_thumb"
                    onChange={(e) => {
                      if (e.target.files.length === 0) {
                        return null;
                      } else {
                        imageUploaded(e);
                      }
                    }}
                    required={loginObj.left_thumb ? false : true}
                  />

                  {loginObj.left_thumb && (
                    <a
                      className="text-decoration-none"
                      rel="noreferrer"
                      target="_blank"
                      href={base_url + loginObj.left_thumb}
                    >
                      View Uploaded File
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <div className="mb-3">
                  <label for="formFile" className="form-label">
                    10 + 2 Marksheet*
                  </label>
                  <input
                    name="senior_marksheet"
                    onChange={(e) => {
                      if (e.target.files.length === 0) {
                        return null;
                      } else {
                        imageUploaded(e);
                      }
                    }}
                    className="form-control"
                    type="file"
                    required={loginObj.senior_marksheet ? false : true}
                  />
                  {loginObj.senior_marksheet && (
                    <a
                      className="text-decoration-none"
                      rel="noreferrer"
                      target="_blank"
                      href={base_url + loginObj.senior_marksheet}
                    >
                      View Uploaded File
                    </a>
                  )}
                </div>
              </div>
              {loginObj.CourseName === "UG" && (
                <>
                  <div className="col-sm-12 col-lg-4">
                    <div className="mb-3">
                      <label for="formFile" className="form-label">
                        NEET Score Card*
                      </label>
                      <input
                        name="NEETmarksheet"
                        onChange={(e) => {
                          if (e.target.files.length === 0) {
                            return null;
                          } else {
                            imageUploaded(e);
                          }
                        }}
                        className="form-control"
                        type="file"
                        required={loginObj.NEETmarksheet ? false : true}
                      />
                      {loginObj.NEETmarksheet && (
                        <a
                          className="text-decoration-none"
                          rel="noreferrer"
                          target="_blank"
                          href={base_url + loginObj.NEETmarksheet}
                        >
                          View Uploaded File
                        </a>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {loginObj.CourseName === "UG" && (
            <>
              <div className="row border border-3 rounded-3 my-3">
                <div className="p-0">
                  <div className="w-100 p-1 pt-2 px-3 form_input_header">
                    <h6 className="text-light">
                      Neet - U.G. - 2024 Information{" "}
                    </h6>
                  </div>
                </div>

                <div className="row p-3">
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">NEET Roll No.</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="NEET Roll No"
                      name="NEETRollNocheck"
                      // value={loginObj.NEETRollNocheck}
                      value={loginObj.neetRollNo}
                      readOnly
                      // onChange={(e) => {
                      //   setLoginObj({
                      //     ...loginObj,
                      //     [e.target.name]: e.target.value,
                      //   });
                      // }}

                      required
                    />
                  </div>

                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">NEET All India Rank</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="NEET All India Rank"
                      name="NEETAIRcheck"
                      value={loginObj.NEETAIR}
                      readOnly
                      // value={loginObj}
                      // value={loginObj.NEETAIRcheck}
                      // onChange={(e) => {
                      //   setLoginObj({
                      //     ...loginObj,
                      //     [e.target.name]: e.target.value,
                      //   });
                      // }}
                      required
                    />
                  </div>

                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label"> Neet Score Obtained</label>
                    <input
                      type="number"
                      className="form-control number-input"
                      placeholder="Neet Score Obtained "
                      name="neetscoreobt"
                      value={loginObj.neetscoreobt}
                      readOnly
                      // value={loginObj.neetscoreobt}
                      // onChange={(e) => {
                      //   setLoginObj({
                      //     ...loginObj,
                      //     [e.target.name]: e.target.value,
                      //   });
                      // }}

                      required
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Declaration</h6>
              </div>
            </div>

            <div className="row p-3">
              <div className="col-12">
                <p>
                I have filled complete information by self and confirm that
                I am resident of Punjab state /U.T. of Chandigarh. I understand
                that if the above information is found incorrect at any stage, 
                my candidature for admission shall stand cancelled. I shall remain
                in touch with the University for knowing the outcome regarding my 
                admission and regularly check the University website for updates.
                </p>
              </div>
              <div className="col-12">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <label className="form-check-label">I Agree</label>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-around my-5">
            <button
              type="submit"
              className="btn btn-primary w-25"
              disabled={!isChecked}
            >
              Submit
              {fp3loader && <Loader />}
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

export default FormPage3;
